module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__extrasize",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Тип расчёта",
      "required": true,
      "name": "type",
      "id": "type",
      "data-vv-as": ' ',
      "data-vv-name": "type",
      "error": _vm.errors.first('type')
    },
    model: {
      value: (_vm.extrasize.type),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "type", $$v)
      },
      expression: "extrasize.type"
    }
  }, [_c('option', {
    attrs: {
      "default": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(" Выбрать... ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weight"
    }
  }, [_vm._v(" По весу ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "volume"
    }
  }, [_vm._v(" По объёму ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dimensions"
    }
  }, [_vm._v(" По габариту ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dimensionssum"
    }
  }, [_vm._v(" По сумме габаритов ")])]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Тип наценки",
      "required": true,
      "name": "markup_type",
      "id": "markup_type",
      "data-vv-as": ' ',
      "data-vv-name": "markup_type",
      "error": _vm.errors.first('markup_type')
    },
    model: {
      value: (_vm.extrasize.markup_type),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "markup_type", $$v)
      },
      expression: "extrasize.markup_type"
    }
  }, [_c('option', {
    attrs: {
      "default": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(" Выбрать... ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Числовая ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(" Процентная ")])]), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "min",
      "id": "min",
      "label": ('Минимум ' + _vm.sizeUnits),
      "required": true,
      "error": _vm.errors.first('min'),
      "type": "number",
      "data-vv-as": ' ',
      "data-vv-name": "min"
    },
    model: {
      value: (_vm.extrasize.min),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "min", $$v)
      },
      expression: "extrasize.min"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.001,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "max",
      "id": "max",
      "label": ('Максимум ' + _vm.sizeUnits),
      "required": true,
      "error": _vm.errors.first('max'),
      "type": "number",
      "data-vv-as": ' ',
      "data-vv-name": "max"
    },
    model: {
      value: (_vm.extrasize.max),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "max", $$v)
      },
      expression: "extrasize.max"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        min_value: 0.01,
        max_value: 9999999999,
        decimal: [2, '.']
      }),
      expression: "{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Величина наценки",
      "name": "markup_value",
      "id": "markup_value",
      "required": true,
      "error": _vm.errors.first('markup_value'),
      "type": "number",
      "data-vv-as": ' ',
      "data-vv-name": "markup_value"
    },
    model: {
      value: (_vm.extrasize.markup_value),
      callback: function($$v) {
        _vm.$set(_vm.extrasize, "markup_value", $$v)
      },
      expression: "extrasize.markup_value"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b49bb30","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/extrasize/FreightExtrasize.vue
// module id = 1206
// module chunks = 0